import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ModalController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject} from 'rxjs';
import {Api} from 'src/smoothr-web-app-core/api/api';
import Order from 'src/smoothr-web-app-core/models/Order';
import PromoCode from 'src/smoothr-web-app-core/models/PromoCode';
import {AnalyticsService} from 'src/smoothr-web-app-core/services/analytics/analytics.service';
import {RepositoryService} from 'src/smoothr-web-app-core/services/repository/repository.service';
import {OrderUtils} from 'src/smoothr-web-app-core/utils/order-utils';
import {axiosErrorToMessage} from 'src/smoothr-web-app-core/utils/utils';
import {AlertInfoModalComponent} from '../alert-info-modal/alert-info-modal.component';

@Component({
	selector: 'app-vitalcode',
	templateUrl: './vitalcode.component.html',
	styleUrls: ['./vitalcode.component.scss']
})
export class VitalcodeComponent implements OnInit {
	public vitalCodeInput = new FormControl();
	public loading$ = new BehaviorSubject<boolean>(false);
	inputCode: string = null;
	_order: Order;
	@Input() set order(order: Order) {
		this._order = order;
		if (this._order && this._order.promoCode && this._order.promoCode.code) {
			this.inputCode = this._order.promoCode;
			this.vitalCodeInput.patchValue(this._order.promoCode.code);
		}
		// if (value) {
		// 	this.inputCode = value;
		// 	this.vitalCodeInput.patchValue(value);
		// }
	}
	// @Input() order: Order;
	@Output() vitalCode = new EventEmitter<string>();
	@Output() successOrder = new EventEmitter<Order>();
	constructor(
		private snackBar: MatSnackBar,
		private analytics: AnalyticsService,
		private modalCtrl: ModalController,
		private translate: TranslateService,
		private repository: RepositoryService
	) {}

	ngOnInit() {}
	// loadCode() {
	// 	this.inputCode = this.vitalCodeInput?.value;
	// 	this.vitalCode.emit(this.vitalCodeInput?.value);
	// }
	deleteCode() {
		this.inputCode = null;
	}
	async loadCode() {
		if (!this.vitalCodeInput?.value || this.vitalCodeInput?.value.replace(' ', '').length === 0) {
			await AlertInfoModalComponent.show(
				this.modalCtrl,
				this.translate.instant('promo_code.not_valid'),
				null,
				null,
				this.translate.instant('change_time_alert.cancel')
			);
			return;
		}
		this.loading$.next(true);
		try {
			this.inputCode = this.vitalCodeInput?.value;
			this.loading$.next(false);
		} catch (e) {
			console.log(e);
			this.loading$.next(false);
			if (e.response.status === 404) {
				await AlertInfoModalComponent.show(
					this.modalCtrl,
					null,
					this.translate.instant('promo_code.not_valid'),

					null,
					this.translate.instant('change_time_alert.cancel')
				);
				return;
			}
			return;
		}
	}
}
